import { useState, type FC } from 'react'
import { Form } from 'react-bootstrap'
import classNames from 'classnames'
import { Modal } from '../../../components/Modal/Modal'

const MAX_REASON_LENGTH = 200

interface BookingReasonDialogProps {
  title: string
  body: string
  note?: string
  confirmLabel: string
  cancelLabel?: string
  isLoading?: boolean
  onConfirm: (reason: string) => void
  onCancel: () => void
}

export const BookingReasonDialog: FC<BookingReasonDialogProps> = ({
  title,
  body,
  note,
  confirmLabel,
  cancelLabel = 'Cancel',
  isLoading = false,
  onConfirm,
  onCancel,
}) => {
  const [reason, setReason] = useState('')
  const remainingCharacters = MAX_REASON_LENGTH - reason.length

  return (
    <Modal
      show
      footerClassName='p-4 pt-0'
      onHide={isLoading ? undefined : onCancel}
      header={<h5 className='mb-0'>{title}</h5>}
      headerBodySeparator
      body={
        <div className='d-flex flex-column gap-4'>
          <div className='paragraph-medium'>{body}</div>
          <div className='d-flex flex-column zocks-gap-0.5'>
            <Form.Label className='mb-0 paragraph-small'>
              <span className='bold'>Add a message</span> <span className='zocks-text-gray-600'>(optional)</span>
            </Form.Label>
            {note != null ? <span className='paragraph-small zocks-text-gray-700'>{note}</span> : null}
            <Form.Control
              as='textarea'
              rows={5}
              value={reason}
              maxLength={MAX_REASON_LENGTH}
              placeholder='Type your message'
              onChange={(event) => setReason(event.currentTarget.value)}
            />
            <div
              className={classNames('paragraph-extra-small text-end', {
                'zocks-text-gray-600': remainingCharacters > 0,
                'zocks-text-danger-200': remainingCharacters === 0,
              })}
            >
              {remainingCharacters} characters left
            </div>
          </div>
        </div>
      }
      showFooterActions
      footerPrimaryActionTitle={confirmLabel}
      footerPrimaryActionButtonVariant='danger'
      footerPrimaryActionLoading={isLoading}
      footerSecondaryActionTitle={cancelLabel}
      footerSecondaryActionDisabled={isLoading}
      onFooterPrimaryAction={() => onConfirm(reason.trim())}
      onFooterSecondaryAction={onCancel}
    />
  )
}
